import { fetcher } from '@commenda/utils';

export async function deleteMember({
  companyId,
  userId,
}: {
  companyId: number;
  userId: string;
}): Promise<Response> {
  const res = await fetcher(`company/${companyId}/member/${userId}`, {
    method: 'DELETE',
  });

  return res;
}
